import { Stack } from '@fluentui/react';
import { AlertDialog } from 'common/components/AlertDialog';
import { useEffect, useState } from 'react';
import {
  CompanyConfigurationCategories_companyConfigurationCategories_nodes,
  CompanyConfigurationCategories_Query,
} from '../__generated__/CompanyConfigurationCategories';
import { CategoryHeader } from './CategoryHeader';
import { useStyles } from './index.styles';
import { useSubmitForm } from '../hooks/useSubmitForm';
import { EditRuleViewValues } from '../SelectedCategoryRulesView/types';
const CONFIRM_DIALOG_TITLE = 'Unsaved Changes !';
const CONFIRM_DIALOG_SUBTEXT = 'Do you want to save your changes ? ';

interface BusinessRulesLeftPanelProps {
  data: CompanyConfigurationCategories_Query | undefined;
  setSelectedNode: React.Dispatch<
    React.SetStateAction<
      | CompanyConfigurationCategories_companyConfigurationCategories_nodes
      | undefined
    >
  >;
  isDirty: boolean;
  values: EditRuleViewValues | undefined;
  selectedNode:
    | CompanyConfigurationCategories_companyConfigurationCategories_nodes
    | undefined;
  refreshConfigurationWarning: () => void;
}

export const BusinessRulesLeftPanel: React.FC<BusinessRulesLeftPanelProps> = ({
  data,
  setSelectedNode,
  isDirty,
  values,
  selectedNode,
  refreshConfigurationWarning,
}) => {
  const styles = useStyles();
  const categories = data?.companyConfigurationCategories?.nodes;
  const [selectedNodeId, setSelectedNodeId] = useState<string | undefined>(
    undefined
  );
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const _headerOnClick = (
    selectedNode: CompanyConfigurationCategories_companyConfigurationCategories_nodes
  ) => {
    setSelectedNode(selectedNode);
    setSelectedNodeId(selectedNode.id);
  };
  const { submitForm } = useSubmitForm();
  const [clickedItem, setClickedItem] = useState<
    | CompanyConfigurationCategories_companyConfigurationCategories_nodes
    | undefined
  >(selectedNode);
  const handleSubmit = async () => {
    if (values && selectedNode) {
      const isSubmitted = await submitForm(values, selectedNode);
      return isSubmitted;
    }
  };

  useEffect(() => {
    if (selectedNodeId) {
      const item = data?.companyConfigurationCategories?.nodes?.find(
        (node) => node.id === selectedNodeId
      );
      setSelectedNode(item);
      setSelectedNodeId(item?.id);
    } else {
      setSelectedNode(data?.companyConfigurationCategories?.nodes?.[0]);
      setSelectedNodeId(data?.companyConfigurationCategories?.nodes?.[0]?.id);
    }
  }, [data]);

  return (
    <Stack
      grow
      tokens={{ childrenGap: 10 }}
      className={styles.leftPanelContainer}
    >
      <Stack tokens={{ childrenGap: 8 }}>
        {categories?.map((item) => (
          <>
            <CategoryHeader
              id={item.id}
              isSelected={selectedNodeId === item.id}
              node={item}
              headerOnClick={() => {
                if (isDirty) {
                  setClickedItem(item);
                  setShowAlert(true);
                } else _headerOnClick(item);
              }}
            />
          </>
        ))}
      </Stack>
      <AlertDialog
        hidden={!showAlert}
        title={CONFIRM_DIALOG_TITLE}
        subText={CONFIRM_DIALOG_SUBTEXT}
        onConfirm={async () => {
          setShowAlert(false);
          const isSubmitted = await handleSubmit();
          if (clickedItem && isSubmitted) {
            _headerOnClick(clickedItem);
            refreshConfigurationWarning();
          }
        }}
        onCancel={() => {
          setShowAlert(false);
        }}
      />
    </Stack>
  );
};
